import React from "react";

const TermsAndConditions = () => {
  return (
    <div class="t-and-cs">
      <p>Updated: 2nd September 2025</p>
      <hr />
      <h3 id="-why-are-these-terms-and-conditions-important-to-me-">
        <strong>Why are these Terms and Conditions important to me?</strong>
      </h3>
      <p>
        These Terms and Conditions are important to you because they apply if
        you sell your LEGO® bricks to us as part of the LEGO Brick Take Back
        program. We strongly recommend that you read these Terms and Conditions
        carefully before entering into a contract with us.
      </p>
      <hr />
      <h3 id="-how-are-these-terms-and-conditions-structured-">
        <strong>How are these Terms and Conditions structured?</strong>
      </h3>
      <p>
        We have drafted these Terms and Conditions in a format of questions and
        answers in order to make it easier for you to understand them. All
        questions below are drafted from the perspective of you as the seller.
        Therefore, within the questions, you will be referred to as “I,” “my,”
        or “me.” Within the answers, you will be referred to as “you,” “your,”
        or “seller.”
      </p>
      <hr />
      <h3 id="-in-these-terms-and-conditions-you-will-find-the-answers-to-the-following-questions-">
        <strong>
          In these Terms and Conditions, you will find the answers to the
          following questions:
        </strong>
      </h3>
      <ol>
        <li>
          <p>
            <a href="#section1">When do these Terms and Conditions apply?</a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section2">
              What is the LEGO® Brick Take Back program, and how does it work?
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section3">
              When do I enter into a legally binding contract with you?
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section4">Can I donate my bricks?</a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section5">What items are eligible?</a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section6">
              How is the price determined, and how do I get paid?
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section7">What are we liable for?</a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section8">
              What should I do if I am not satisfied with my LEGO® Brick Take
              Back experience?
            </a>
          </p>
        </li>
        <li>
          <p>
            <a href="#section9">
              What law applies to these Terms and Conditions?
            </a>
          </p>
        </li>
      </ol>
      <hr />
      <h3 id="section1">
        <strong>1. When do these Terms and Conditions apply?</strong>
      </h3>
      <p>
        <strong>
          1.1 Who is the contracting party that I am selling my LEGO® bricks
          to?
        </strong>
      </p>
      <p>
        Your contracting party within the following Terms and Conditions for the
        selling of used LEGO bricks (“<strong>Terms and Conditions</strong>”) is
        Pentatonic Ltd. UK and its subsidiary Infinitum Technologies, Inc., 2140
        S Dupont Highway, Camden, DE 19934 (“<strong>Pentatonic</strong>”).
      </p>
      <p>
        Please note that Pentatonic acts as an intermediate buyer and will sell
        the LEGO Bricks to LEGO Systems, Inc., 100 Print Shop Road, Enfield, CT
        06082 (“<strong>LEGO Systems, Inc.</strong>, ”<strong>we</strong>,” “
        <strong>us</strong>,” or “<strong>our</strong>”) meaning that LEGO
        Systems, Inc. or its affiliated companies will receive your LEGO Bricks
        afterwards. LEGO Systems, Inc. is a subsidiary of LEGO System A/S,
        Åstvej 1, 7190 Billund, Denmark (“<strong>LEGO System A/S</strong>”).
      </p>
      <p>
        You as the seller will be referred to as “<strong>you</strong>,” “
        <strong>your</strong>,” or “<strong>seller</strong>” in the answers to
        the questions below.
      </p>
      <p>
        We reserve the right to assign our rights and obligations under these
        Terms and Conditions without requiring your consent.
      </p>
      <p>
        <strong>1.2 Who do these Terms and Conditions apply to?</strong>
      </p>
      <p>
        These Terms and Conditions apply to any individual consumer that chooses
        to enter into a contract with us by selling LEGO® bricks to us within
        the United States of America. To participate in the LEGO Brick Take Back
        program, you must be at least 18 years old. Additionally, as a condition
        for participating in the program and entering into this contract, you
        must be the owner of the LEGO bricks that are the subject of the take
        back and/or have the legal right to transfer title of these bricks to
        Pentatonic.
      </p>
      <p>
        <strong>
          1.3 Can I also sell my LEGO® bricks if I act in my capacity as a
          business?
        </strong>
      </p>
      <p>
        No, we only offer to take back LEGO bricks if you are an individual
        consumer. Therefore, all legally recognized entities, including
        businesses, government agencies, non-profits, associations,
        partnerships, and other corporate entities, are explicitly excluded
        under these Terms and Conditions.
      </p>
      <hr />
      <h3 id="section2">
        <strong>
          2. What is the LEGO® Brick Take Back program, and how does it work?
        </strong>
      </h3>
      <p>
        <strong>2.1 What is the LEGO® Brick Take Back program?</strong>
      </p>
      <p>
        We’re looking for ways to keep LEGO bricks in play. Sell back your
        bricks and help us explore new options for passing on the joy of play.
      </p>
      <p>
        <strong>2.2 Where can I sell my LEGO® bricks?</strong>
      </p>
      <p>
        The LEGO Brick Take Back program offers three methods for selling your
        eligible LEGO bricks in the United States.
      </p>
      <p>
        <strong>
          2.2.1 Method 1: In-person take back at select LEGO® brand retail
          stores.
        </strong>
      </p>
      <p>
        After visiting the official LEGO Brick Take Back program website (
        <a href="http://www.LEGOBrickTakeBack.com">www.LEGOBrickTakeBack.com</a>
        ) to complete the online application form and set an appointment, you
        can bring your LEGO bricks directly to select LEGO brand retail stores
        listed below. Our staff will assist you with weighing and processing
        your bricks on site. There is a weight limit of 100 lbs. per
        appointment.
      </p>
      <p>
        <strong>Method 1 Participating Locations:</strong>
      </p>
      <p>LEGO Store Colorado Mills</p>
      <p>14500 W Colfax Ave, Lakewood, CO 80401</p>
      <p>LEGO Store Pinnacle Hills</p>
      <p>2203 S Promenade Blvd, Suite 8135, Rogers, AR 72758</p>
      <p>
        <strong>
          2.2.2 Method 2: At-Home Package Preparation and In-Store Drop Off at
          select LEGO® brand retail stores.
        </strong>
      </p>
      <p>
        After visiting the official LEGO Brick Take Back program website (
        <a href="http://www.LEGOBrickTakeBack.com">www.LEGOBrickTakeBack.com</a>
        ) to complete the online application form, you can bring your LEGO
        bricks directly to select LEGO brand retail stores listed below. LEGO
        bricks must be packaged in a sturdy cardboard shipping box ready for
        shipment and weigh no more than 25 lbs. Our staff will assist you with
        weighing and drop-off steps on site.
      </p>
      <p>
        <strong>Method 2 Participating Locations:</strong>
      </p>
      <p>LEGO Store The Mills at Jersey Gardens</p>
      <p>651 Kapkowski Rd, #1008, Elizabeth, NJ 07201</p>
      <p>LEGO Store Ross Park Mall</p>
      <p>1000 Ross Park Mall Dr, D04, Pittsburgh, PA 15237</p>
      <p>
        <strong>2.2.3 Method 3: Mail-In Option.</strong>
      </p>
      <p>
        You may also choose to mail your LEGO® bricks directly to us. To do so:
      </p>
      <ol>
        <li>
          <p>
            Visit the official LEGO Brick Take Back program website:{" "}
            <a href="http://www.LEGOBrickTakeBack.com">
              www.LEGOBrickTakeBack.com
            </a>
          </p>
        </li>
        <li>
          <p>Complete the online application form.</p>
        </li>
        <li>
          <p>Follow the instructions provided to pack and ship your bricks.</p>
          <p> See section 2.5 for details.</p>
        </li>
      </ol>
      <p>
        <strong>
          2.3 Who is administering the LEGO® Brick Take Back program?
        </strong>
      </p>
      <p>
        We are proud to partner with Pentatonic to assist us in processing your
        brick take backs. Pentatonic will be assisting us with both in-store and
        mail-in processing. Please be aware that you will interact with and may
        receive communications from both LEGO Systems, Inc. and Pentatonic
        during your brick take back experience.
      </p>
      <p>
        <strong>
          2.4 How can I sell LEGO® bricks at select LEGO brand retail stores?
        </strong>
      </p>
      <p>
        For participating LEGO brand retail stores listed in section 2.2.1, when
        creating a take back on the program website, you will be asked to select
        a date and time for your in-store appointment. Bring your used LEGO
        bricks to your in-store appointment, where we will use scales to
        determine the weight of your used LEGO bricks, which will in turn be
        used to calculate your payment.
      </p>
      <p>
        For participating LEGO brand retail stores listed in section 2.2.2, once
        the take back has been created, you must pack your LEGO bricks in a
        sturdy cardboard box suitable for shipping. Bring this box to one of the
        specified stores, where we will review your LEGO bricks and use scales
        to determine the weight of your used LEGO bricks, which will in turn be
        used to calculate your payment.
      </p>
      <p>
        <strong>2.5 How can I sell LEGO® bricks via the mail?</strong>
      </p>
      <p>
        The LEGO Brick Take Back program website features a step-by-step
        application to guide you through the process of completing your take
        back on the program website. Once an application is completed and your
        take back successfully created, you will be provided with pre-paid
        shipping options containing instructions that you can use to send your
        LEGO bricks to us.
      </p>
      <p>
        You will then need to follow the packaging instructions, box up your
        LEGO bricks, and take the box to the correct shipping location to
        process the shipment.
      </p>
      <p>
        <strong>
          Note that packages shipped to the LEGO Brick Take Back program cannot
          exceed a total weight of 25 pounds.
        </strong>{" "}
        Packages that fall outside the accepted limit will be handled at our
        discretion. It is your responsibility to ensure the adequate and secure
        packaging of your LEGO bricks for transportation. LEGO bricks must be
        packaged in sturdy cardboard boxes that are in excellent condition and
        rated for the weight of its contents. LEGO bricks must not be packaged
        in other receptacles such as polybags, plastic totes, etc. Please note
        that free shipping is provided only if UPS Ground services is available
        as an origin point in the ZIP code of the address used to create your
        LEGO Brick Take Back account. If the UPS® Ground services is not
        available in the ZIP code as an origin point, then you are responsible
        for shipping and all related shipping costs.
      </p>
      <hr />
      <h3 id="section3">
        <strong>
          3. When do I enter into a legally binding contract with you?
        </strong>
      </h3>
      <p>
        <strong>3.1 When do I enter into this contract with you?</strong>
      </p>
      <p>
        For retail store take backs &amp; drop offs, our staff will weigh your
        bricks and tell you exactly at what price we will take back the bricks
        from you. Details on pricing may be found in Section 6 of these Terms
        and Conditions. Once one of our staff members has examined your LEGO®
        bricks and has offered you a specific price for the take back, this
        constitutes a legally binding offer. Once the offer has been made, you
        may still decide whether you want to sell your LEGO bricks at this price
        or not. If you decide to accept our offer and you communicate this
        acceptance to our staff member, you will enter into a legally binding
        contract with Pentatonic.
      </p>
      <p>
        For mail-in take backs, you will provide us with an estimated weight of
        your bricks. Please be as accurate with this weight as possible, so that
        we can provide you with the most accurate payment estimate. Once you
        have provided us with the weight, we will calculate the estimated LEGO
        e-Gift Card reward value. After reviewing the estimate, you may still
        decide whether you want to sell your LEGO bricks or not. Once you
        complete and submit your take back application, you will enter into a
        legally binding contract with Pentatonic conditioned on you sending your
        bricks by using the applicable shipping label. The actual payment amount
        for your mail-in take back will be calculated once we receive your
        package, have examined the contents and removed any ineligible items,
        and have calculated the actual weight of the eligible bricks. By sending
        in your items, you agree to accept the payout value determined by
        Pentatonic, without expectation of any item return.
      </p>
      <p>
        <strong>
          Please note that if and when the offered price is changed and your
          shipment has not yet been received by the shipping carrier, the
          shipping label and offer may no longer be available to you. In this
          case, in order to participate, you would need to resubmit your take
          back application and enter into a new agreement with Pentatonic.
        </strong>
      </p>
      <p>
        <strong>
          3.2 When does Pentatonic become the owner of the bricks (i.e.,
          transfer of title)?
        </strong>
      </p>
      <p>
        For in-store take backs, the title to the LEGO® bricks shall transfer
        to Pentatonic once our staff member has confirmed the eligibility of
        your LEGO bricks according to Sections 5.1 and 5.2 of these Terms and
        Conditions, and you have accepted our price offer and entered into a
        contract with Pentatonic according to Section 3.1. You shall not retain
        any title to the bricks thereafter.
      </p>
      <p>
        For mail-in take backs, the title to the LEGO bricks and any other
        contents of your package shall transfer to Pentatonic upon receipt of
        your package by the shipping carrier. Once the package ships and is on
        its way to us, you shall not retain any title to the bricks, or any
        other items included in the package thereafter. Please note that we will
        not return any bricks or other elements or items that we deem in our
        discretion are ineligible for take back. Pentatonic will retain title to
        these mailed-in ineligible items and will not return them to you. Thus,
        we encourage you to carefully review the contents of your package prior
        to shipment.
      </p>
      <hr />
      <h3 id="section4">
        <strong>4. Can I donate my bricks?</strong>
      </h3>
      <p>
        <strong>4.1 Can I donate some or all of my bricks?</strong>
      </p>
      <p>
        Yes, for mail-in take backs only, you will be presented with the option
        to donate some or all of your bricks to the{" "}
        <a href="https://www.lego.com/en-us/sustainability/replay?cid=takeback-website:terms-and-conditions">
          LEGO® Replay program
        </a>
        . When selecting this option, you will be able to indicate the
        percentage amount of your total eligible donation weight you would like
        to be donated to the LEGO Replay program. The final total donation
        weight will be based on the actual weight of received LEGO bricks, minus
        the total weight of any ineligible items. (See Section 5 for more
        details). Note that you will not be compensated in any way for the
        bricks donated to the LEGO Replay program, as this is a voluntary
        donation program.
      </p>
      <p>
        The LEGO bricks set aside for donation will be picked randomly from the
        eligible LEGO bricks we have received. This means that we cannot
        guarantee which specific LEGO bricks will be donated.
      </p>
      <p>
        <strong>4.2 What is the LEGO® Replay program?</strong>
      </p>
      <p>
        The LEGO Replay program collects previously used LEGO bricks directly
        from consumers, cleans and repackages them, and partners with nonprofits
        to distribute boxes to educators and charitable organizations across the
        U.S. For more information, visit
        www.lego.com/en-us/sustainability/replay.
      </p>
      <hr />
      <h3 id="section5">
        <strong>5. What items are eligible?</strong>
      </h3>
      <p>
        <strong>5.1 What kind of LEGO® bricks are eligible?</strong>
      </p>
      <p>
        We specifically want to take back LEGO bricks, elements, and baseplates
        that have been used in the past. Therefore, we do not expect your LEGO
        bricks to be in mint condition. However, we reserve the right to reject
        any LEGO bricks if they are not in a reasonable condition. LEGO bricks
        are not in a reasonable condition if one of our staff members in their
        discretion determines that (a) an appreciable number of the bricks are
        cracked and/or significantly worn, or (b) the bricks may pose a health
        or safety risk.
      </p>
      <p>
        <strong>5.2 What items are ineligible?</strong>
      </p>
      <p>
        For the time being, we are not able to take back the following bricks or
        elements:
      </p>
      <ul>
        <li>
          <p>Non-LEGO® bricks and elements</p>
        </li>
        <li>
          <p>Assembled LEGO sets or connected bricks</p>
        </li>
        <li>
          <p>LEGO DUPLO® bricks and elements</p>
        </li>
        <li>
          <p>Electronic components or batteries</p>
        </li>
        <li>
          <p>
            Any other LEGO branded items such as apparel, key chains, storage
            containers, building instructions and packaging
          </p>
        </li>
      </ul>
      <p>
        Therefore, we strongly encourage you to remove any of the listed items
        before arrival at our in-store location or before packaging your mail-in
        LEGO bricks, and only include disassembled LEGO bricks and elements. For
        mail-in take backs, any ineligible bricks, elements, or other items will
        be removed prior to calculation of the weight and will not be returned
        to you. We reserve the right to change the list of ineligible items at
        any time and for any reason at our sole discretion.
      </p>
      <p>
        <strong>
          5.3 How does the removal of ineligible items impact my donation to
          LEGO® Replay?
        </strong>
      </p>
      <p>
        If any ineligible items are found and removed from your package, the
        weight of those items will first be subtracted from the amount
        originally designated for donation. If and once the weight of those
        ineligible items exceeds the amount originally designated for donation,
        it is then that the weight of those ineligible items will be subtracted
        from the weight of eligible items.
      </p>
      <hr />
      <h3 id="section6">
        <strong>6. How is the price determined, and how do I get paid?</strong>
      </h3>
      <p>
        <strong>6.1 How is the price determined for my LEGO® bricks?</strong>
      </p>
      <p>
        The price we offer for the take back of LEGO bricks is determined by the
        weight of the bricks. We offer designated prices based on the pure
        weight of the eligible bricks. Any means of storage for the bricks
        (e.g., bags or boxes) and any non-genuine LEGO bricks and other
        ineligible items listed in Section 5.2 are not included when determining
        the weight. The prices we offer per pound (lb) may vary between the
        different LEGO brand retail stores and for mail-in take backs and may be
        subject to changes from time to time. We reserve the right to make
        changes to our pricing at any time and for any reason at our sole
        discretion.
      </p>
      <p>
        <strong>6.2 How can I get paid for my LEGO® bricks?</strong>
      </p>
      <p>
        Payment will be provided in the form of LEGO® e-Gift Cards. LEGO e-Gift
        Cards are issued in reward values in US dollars (“USD”).
      </p>
      <p>
        For in-store take backs &amp; drop offs, after your LEGO bricks have
        been weighed by one of our staff members according to Section 2.4, we
        will offer you a means of payment by indicating a reward value in USD
        for a LEGO e-Gift Card. Once your payment has been confirmed by you,
        your choice will be final.
      </p>
      <p>
        For mail-in take backs, once you provide us with the estimated weight of
        your bricks, we will provide you with an estimated payment for a LEGO
        e-Gift Card. Once we receive your shipment of bricks and have calculated
        the actual weight of eligible bricks, we will determine the final
        payment amount. Once processed, we will automatically issue a LEGO
        e-Gift Card to the email address you provided in your LEGO Brick Take
        Back application.
      </p>
      <p>
        <strong>6.3 Where can I use the LEGO® e-Gift Cards?</strong>
      </p>
      <p>
        You can find information on how to redeem your LEGO e-Gift Card{" "}
        <a href="https://www.lego.com/en-us/gift-cards">here</a>.
      </p>
      <hr />
      <h3 id="section7">
        <strong>7. What are we liable for?</strong>
      </h3>
      <p>
        <strong>
          We and Pentatonic are only liable for loss or damage due to gross
          negligence. In no event will we or Pentatonic be liable for any direct
          or indirect, incidental, statutory, exemplary, punitive, special, or
          consequential damages as a result of any claims, whether arising under
          tort, breach of contract, strict liability, or otherwise, related to
          your participation in the LEGO® Brick Take Back program. We and
          Pentatonic disclaim any and all warranties to the fullest extent
          permissible under the law.
        </strong>
      </p>
      <hr />
      <h3 id="section8">
        <strong>
          8. What should I do if I am not satisfied with my LEGO® Brick Take
          Back experience?
        </strong>
      </h3>
      <p>
        If you in general are not happy with your LEGO Brick Take Back
        experience, we invite you to reach out to our customer service team at
        Support@LEGOBrickTakeBack.com and we will try to find the best solution
        to address your concerns.
      </p>
      <hr />
      <h3 id="section9">
        <strong>9. What law applies to these Terms and Conditions?</strong>
      </h3>
      <p>
        These Terms and Conditions and all matters arising out of or relating to
        these Terms and Conditions are governed by, and construed in accordance
        with, the laws of the State of New York, United States of America,
        without regard to the conflict of law provisions thereof to the extent
        such principles or rules would require or permit the application of the
        laws or any jurisdiction other than those of the State of New York. As
        you are contracting as a consumer, this will not affect your statutory
        rights. The UN Convention on Contracts for the International Sale of
        Goods shall not apply to this Agreement.
      </p>
      <hr />
    </div>
  );
};

export default TermsAndConditions;
